const stripChanges = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;

    // Avoid mutating the original object.
    const { changes, ...rest } = obj;
    return rest;
};

export default function objChangeDetection(
    serverJson = [],
    newServerJson = [],
) {
    if (!Array.isArray(serverJson) || !serverJson.length) {
        // First snapshot: mark everything as unchanged but keep the shape stable.
        return (newServerJson || []).map((item) => ({
            ...item,
            changes: null,
        }));
    }

    const prevById = new Map(serverJson.map((s) => [s?.id, s]));

    return (newServerJson || []).map((nextObj) => {
        const prevObj = prevById.get(nextObj?.id);

        if (!prevObj) {
            return { ...nextObj, changes: 'added' };
        }

        // Deep-ish equality using JSON.stringify is enough here because:
        // - we only use it to detect changes between consecutive server payloads
        // - the backend object key order is stable
        const prevComparable = stripChanges(prevObj);
        const nextComparable = stripChanges(nextObj);
        const isSame =
            JSON.stringify(prevComparable) === JSON.stringify(nextComparable);

        if (isSame) {
            // Preserve object identity to prevent re-render churn.
            if (prevObj?.changes == null) return prevObj;
            return { ...prevObj, changes: null };
        }

        return { ...nextObj, changes: 'modified' };
    });
}
